const SHOW_YOTI_MODAL = 'SHOW_YOTI_MODAL';
const HIDE_YOTI_MODAL = 'HIDE_YOTI_MODAL';

export { SHOW_YOTI_MODAL, HIDE_YOTI_MODAL };
